var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeroBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 2659.066 3253.656"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33406",
  opacity: 0.6,
  style: {
    mixBlendMode: "soft-light",
    isolation: "isolate"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13175",
  d: "m-.12 514.394 345.7 1289.366 229.027 22.562L2113.513 722.706Z",
  fill: "#282828"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13176",
  d: "m387.59 1960.448 346.795 1293.45L2465.2 2012.628 574.605 1826.312Z",
  fill: "#282828"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13177",
  d: "m574.615 1826.31 1890.596 186.316.028-.007L2119.555 723.31l-6.088-.603Z"
}))));
export default SvgHeroBackground;